import styled from 'styled-components'

export const StyledTextPage = styled.div`
max-width: 1024px;
display: table;
flex-direction: column;
background: ${({ textLayout }) => textLayout === 'inverse' ? '#fdfdfd' : 'none'};
color: ${({ textLayout }) => textLayout === 'inverse' ? '#000' : '#fdfdfd'};
border-radius: 1rem;
padding: 2rem;
margin-top: 1.5rem;
border-radius: unset;
text-align: left;
h2 {
  font-weight: 400;
  background: none;
  margin-bottom: 2rem;
  text-align: center;
}
p {
  font-weight: 300;
  line-height: 1.5;
  text-align: ${({ styling }) => styling?.textAlign || 'left'};
}
.novel {
  font-family: sans-serif;
  font-size:0.8em;
  line-height:0;
}

img {
  width: 20rem;
  height: auto;
  }

  li {
    list-style-position: outside;
    line-height: 1.5;
    text-align: left;
  }
  
  ol > li {
    list-style-position: outside;
    line-height: 1.5;
  }
}
`
